import { render, staticRenderFns } from "./voucherCreateScm8StoreBill.vue?vue&type=template&id=f08c06f6&scoped=true&"
import script from "./voucherCreateScm8StoreBill.vue?vue&type=script&lang=js&"
export * from "./voucherCreateScm8StoreBill.vue?vue&type=script&lang=js&"
import style0 from "./voucherCreateScm8StoreBill.vue?vue&type=style&index=0&id=f08c06f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08c06f6",
  null
  
)

export default component.exports